import type { FilterCondition } from 'framework/types';
import type { FilterBarFilterOption, FilterValue } from '../../contracts';

export interface FilterBarAutosuggestionFilterConfig {
  type: 'autosuggestion';
  id: string;
  source: string;
  condition: FilterCondition;
  label: string;
  loadOptions: (searchValue: string) => Promise<FilterBarFilterOption[]>;
  resolveOption?: (value: string) => Promise<FilterBarFilterOption | null>;
  minSearchLength?: number;
  resultsLimit?: number;
}

export enum AutosuggestionSearchStatus {
  IDLE = 'idle',
  LOADING = 'loading',
  SUCCESS = 'success',
  ERROR = 'error',
}

export interface AutosuggestionSearchState {
  query: string;
  status: AutosuggestionSearchStatus;
  options: FilterBarFilterOption[];
}

export interface AutosuggestionFilterEditorProps {
  filter: FilterBarAutosuggestionFilterConfig;
  value: FilterValue;
  onChange: (value: FilterValue) => void;
  onClose: () => void;
}
